import { render, staticRenderFns } from "./schoolManagement.vue?vue&type=template&id=79f1d14e&scoped=true"
import script from "./schoolManagement.vue?vue&type=script&lang=js"
export * from "./schoolManagement.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/popUp.scss?vue&type=style&index=0&id=79f1d14e&prod&lang=scss&scoped=true&external"
import style1 from "@/assets/css/tableList.scss?vue&type=style&index=1&id=79f1d14e&prod&lang=scss&scoped=true&external"
import style2 from "./schoolManagement.vue?vue&type=style&index=2&id=79f1d14e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f1d14e",
  null
  
)

export default component.exports